/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/tipping';
import '../common/payment_types';
import '../common/buyer_facing_display';
import '../common/order_tickets';
import '../common/signature';
import '../common/customer_management';
import '../common/payment_sounds';
import '../common/store_and_forward';
import '../common/security';
import '../common/tile';
import '../common/quick_amounts';
import '../common/cart';
import '../addons/invoices';
import '../addons/estimates';
import '../addons/gift_cards';
import '../addons/cash_management';
import '../addons/open_tickets';
import '../addons/team_management';
import '../addons/text_message_marketing';
import '../addons/messages';
import '../addons/loyalty';
import '../addons/online_checkout';
import '../addons/square_online';
import '../addons/buyer_subscriptions';
import '../addons/contracts';
import '../addons/staff';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "ipos": {
                            "nested": {
                              "IPOSSettings": {
                                "fields": {
                                  "tipping": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "paymentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentTypes",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.ipos.IPOSSettings.AddonsSettings",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "buyerFacingDisplay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.BuyerFacingDisplay",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "orderTickets": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "signature": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "customerManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagement",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "storeAndForward": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "tile": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tile",
                                    "id": 11,
                                    "rule": "optional"
                                  },
                                  "quickAmount": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts",
                                    "id": 12,
                                    "rule": "optional"
                                  },
                                  "cart": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Cart",
                                    "id": 13,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "AddonsSettings": {
                                    "fields": {
                                      "invoices": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Invoices",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "estimates": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Estimates",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "giftCards": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.GiftCards",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "cashManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.CashManagement",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "openTickets": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OpenTickets",
                                        "id": 5,
                                        "rule": "optional"
                                      },
                                      "teamManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TeamManagement",
                                        "id": 6,
                                        "rule": "optional"
                                      },
                                      "textMessageMarketing": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                        "id": 7,
                                        "rule": "optional"
                                      },
                                      "messages": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Messages",
                                        "id": 8,
                                        "rule": "optional"
                                      },
                                      "loyalty": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                        "id": 9,
                                        "rule": "optional"
                                      },
                                      "onlineCheckout": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OnlineCheckout",
                                        "id": 10,
                                        "rule": "optional"
                                      },
                                      "squareOnline": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.SquareOnline",
                                        "id": 11,
                                        "rule": "optional"
                                      },
                                      "buyerSubscriptions": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.BuyerSubscriptions",
                                        "id": 12,
                                        "rule": "optional"
                                      },
                                      "contracts": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Contracts",
                                        "id": 13,
                                        "rule": "optional"
                                      },
                                      "staff": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Staff",
                                        "id": 14,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.ipos?.nested?.IPOSSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.ipos?.nested?.IPOSSettings?.nested?.AddonsSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE IPOSSettings @ squareup/devicesettings/profiles/v2/model/settings/ipos/ipos_settings.proto at 44:1
 */
export const IPOSSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.ipos.IPOSSettings');
fixType(IPOSSettings);
Builder.createAndAttachToType(IPOSSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/ipos/ipos_settings.proto at 60:3
 */
IPOSSettings.AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.ipos.IPOSSettings.AddonsSettings');
fixType(IPOSSettings.AddonsSettings);
Builder.createAndAttachToType(IPOSSettings.AddonsSettings);